import $ from 'jquery';
import responsive from '../../vendor/responsive';
import video from '../highlighted-teaser/video';
import '../../vendor/slick';

var sm = responsive.sm;
var md = responsive.md;
var lg = responsive.lg;
var xl = responsive.xl;

doJumbotron();
doTeasers();
doCarouselElaborate();

function doJumbotron() {
  if (!$('.jumbotron .carousel').length) return;

  var container = $('.jumbotron .carousel');
  var animSpeed;
  var autoplaySpeed;

  //check if fade and autoplay speeds have been set manually
  container.attr('data-anim-speed') > -1
    ? (animSpeed = container.attr('data-anim-speed'))
    : (animSpeed = 900);
  container.attr('data-autoplay-speed') > -1
    ? (autoplaySpeed = container.attr('data-autoplay-speed'))
    : (autoplaySpeed = 12000);

  var responsiveSettings = [
    {
      breakpoint: md,
      settings: {
        dots: true,
        arrows: false,
      },
    },
  ];

  container.slick({
    autoplay: true,
    autoplaySpeed: autoplaySpeed,
    fade: true,
    speed: animSpeed,
    mobileFirst: true,
    responsive: responsiveSettings,
    pauseOnHover: false,
  });
}

function doTeasers() {
  if (!$('.teasers.carousel').length) return;

  var container = $('.teasers.carousel');

  var responsiveSettings = [
    {
      breakpoint: sm,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: lg,
      settings: {
        slidesToShow: 3,
        dots: false,
      },
    },
  ];

  container.slick({
    arrows: false,
    dots: true,
    mobileFirst: true,
    slidesToShow: 1,
    responsive: responsiveSettings,
  });
}

function doCarouselElaborate() {
  if (!$('.carousel-elaborate').length) return;

  $('.carousel-elaborate').each(function () {
    var container = $(this);
    var mainVisual = $('.main-visual', container);
    var thumbs = $('.thumbs', container);

    var responsiveSettings = [
      {
        breakpoint: sm,
        settings: {
          arrows: false,
        },
      },
    ];

    if ($('figure[data-video]', container).length > 0) {
      video.doCarousel(container);

      $('figure[data-video]', container).each(function (i) {
        const curIndex = $(this).index();
        $('figure', thumbs).eq(curIndex).append('<span class="video-btn" />');
      });
    }

    mainVisual.slick({
      lazyload: 'ondemand',
      slidesToShow: 1,
      mobileFirst: true,
      fade: true,
      asNavFor: thumbs,
      responsive: responsiveSettings,
    });

    thumbs.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: mainVisual,
      draggable: false,
      focusOnSelect: true,
    });
  });
}
